export default "__VITE_ASSET__Ony4Betu__"